import * as actionTypes from "../types";
import axios from "axios";
import { message } from "antd";

const SOLARFLOW_BASE_URL = "https://pmt.safearth-api.in/api/";

export const requestADemo = (form) => (dispatch) => {
  axios.defaults.headers = {
    "Content-Type": "application/json",
  };
  axios
    .post(`${process.env.REACT_APP_BASE_URL}request_demo/`, form)
    .then((res) => message.success("Thank you! Our team will get back to you."))
    .catch((err) => message.error(err.message));
};

export const getEmailConfirmation = (email) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_OTP_LOADING, payload: null });

  await message.loading("Sending OTP...");

  try {
    const result = await axios.get(
      `${SOLARFLOW_BASE_URL}send_email_confirmation/`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          email: email,
        },
      }
    );
    if (result.data.status === "FAIL") {
      message.error(result.data.response);
      return;
    }

    if (result.status === 200) {
      dispatch({ type: actionTypes.GET_OTP_SUCCESS, payload: result.data });
      message.success(`Confirmation email has been sent to ${email}`);
      return result;
    }
  } catch (err) {
    message.error(err.message);
    return;
  }
};

export const verifyOtp = (form) => async (dispatch) => {
  dispatch({ type: actionTypes.SIGNUP_START, payload: null });

  axios.defaults.headers = {
    "Content-Type": "application/json",
  };

  await message.loading("Verifying OTP...");

  try {
    let res = await axios.post(`${SOLARFLOW_BASE_URL}verify_otp/`, form);

    if (res?.data?.status === "FAIL") {
      throw res.data;
    }

    if (res.status === 200) {
      dispatch({ type: actionTypes.SIGNUP_SUCCESS, payload: null });
      return res;
    }
  } catch (e) {
    if (e?.status === "FAIL") {
      message.error(e.response, 2);
    } else {
      message.error("Error occurred while verifying otp!", 1);
    }
    dispatch({
      type: actionTypes.SIGNUP_FAILURE,
      payload: e.response,
    });
    return e;
  }
};

export const loginUser = (user) => async (dispatch) => {
  // https://pmt.safearth-api.in/rest-auth/login/
  //https://pmt.safearth-api.in/rest-auth/login/

  await dispatch({
    type: actionTypes.LOGIN_LOADING,
    payload: user,
  });

  axios.defaults.headers = {
    "Content-Type": "application/json",
  };

  try {
    let result = await axios.post(
      "https://pmt.safearth-api.in/rest-auth/login/",
      user
    );
    if (result.status === 200) {
      let token = result.data.key;
      localStorage.setItem("solarflowToken", token);
      dispatch({ type: actionTypes.LOGIN_SUCCESS, payload: null });
      return result;
    }
  } catch (e) {
    dispatch({
      type: actionTypes.LOGIN_FAILURE,
      payload: { message: e?.response?.data?.non_field_errors?.[0] },
    });
  }
};

export const vendorRequestFinance = (data, token) => async (dispatch) => {
  dispatch({ type: actionTypes.VENDOR_REQUEST_FINANCE_LOADING });

  await message.loading("Saving...", 1);

  try {
    const result = await axios.post(
      `${SOLARFLOW_BASE_URL}vendor_request_finance/`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      }
    );
    if (result?.data?.status === "FAIL") {
      throw result.data;
    }
    dispatch({
      type: actionTypes.VENDOR_REQUEST_FINANCE_SUCCESS,
      payload: result.data,
    });

    await message.success("Success!", 1);
    return result;
  } catch (e) {
    if (e?.status === "FAIL") {
      message.error(e.response, 2);
    } else {
      message.error("Error occurred while uploading documents!", 1);
    }
    dispatch({ type: actionTypes.VENDOR_REQUEST_FINANCE_FAILURE, payload: e });
    return e;
  }
};

export const customerRequestFinance = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CUSTOMER_REQUEST_FINANCE_LOADING });

  await message.loading("Saving...", 1);

  try {
    const result = await axios.post(
      `${SOLARFLOW_BASE_URL}customer_request_finance/`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (result?.data?.status === "FAIL") {
      throw result.data;
    }
    dispatch({
      type: actionTypes.CUSTOMER_REQUEST_FINANCE_SUCCESS,
      payload: result.data,
    });

    await message.success("Success!", 1);
    return result;
  } catch (e) {
    if (e?.status === "FAIL") {
      message.error(e.response, 2);
    } else {
      message.error("Error occurred while uploading documents!", 1);
    }
    dispatch({
      type: actionTypes.CUSTOMER_REQUEST_FINANCE_FAILURE,
      payload: e,
    });
    return e;
  }
};
